/* eslint-disable @typescript-eslint/require-await */
import { isWeb } from '~/utils/helper/device';
import { invokeChannel, onChannel, sendChannel } from '~/utils/constants';
import { TFileCatalog } from '~/store/file/file.type';

const webHandlers = {
  getOneBookFiles: () => {
    return [];
  },
  getTikuFiles: async () => {
    return [];
  },
  getFlashFiles: async () => {
    return [];
  },
  getFileCatalog: async () => {
    return {};
  },
  getDisks: async () => {
    return [];
  },
  reloadMyCDCase: () => {},
  oneBookFilesChangeListener: () => {},
  tikuFilesChangeListener: () => {},
  flashFilesChangeListener: () => {},
  fileCatalogChangeListener: () => {},
  openOneBook: () => {},
  openFlash: () => {},
  openTiku: () => {},
  openPath: () => {},
  deleteDiskFile: () => {},
};

const desktopHandler = {
  getOneBookFiles: async () => {
    const files = (await window.api.invoke(
      invokeChannel.getOneBookFiles,
    )) as string[];
    return files;
  },
  oneBookFilesChangeListener: (callback: (event: string[]) => void) => {
    window.api.on(onChannel.oneBookFilesChange, ([event]) => {
      callback(event as string[]);
    });
  },
  getTikuFiles: async () => {
    const files = (await window.api.invoke(
      invokeChannel.getTikuFiles,
    )) as string[];
    return files;
  },
  tikuFilesChangeListener: (callback: (event: string[]) => void) => {
    window.api.on(onChannel.tikuFilesChange, ([event]) => {
      callback(event as string[]);
    });
  },
  getFlashFiles: async () => {
    const files = (await window.api.invoke(
      invokeChannel.getFlashFiles,
    )) as string[];
    return files;
  },
  flashFilesChangeListener: (callback: (event: string[]) => void) => {
    window.api.on(onChannel.flashFilesChange, ([event]) => {
      callback(event as string[]);
    });
  },
  getFileCatalog: async () => {
    const files = (await window.api.invoke(
      invokeChannel.getFileCatalog,
    )) as TFileCatalog;
    return files;
  },
  fileCatalogChangeListener: (callback: (event: TFileCatalog) => void) => {
    window.api.on(onChannel.fileCatalogChange, ([event]) => {
      callback(event as TFileCatalog);
    });
  },
  reloadMyCDCase: (callback: () => Promise<void>) => {
    window.api.on(onChannel.reloadMyCDCase, () => {
      void callback();
    });
  },
  openOneBook: (path: string) => {
    window.api.send(sendChannel.openOneBook, path);
  },
  openFlash: (path: string) => {
    window.api.send(sendChannel.openFlash, path);
  },
  getDisks: async () => {
    const files = (await window.api.invoke(invokeChannel.getDisks)) as string[];
    return files;
  },
  openTiku: (path: string) => {
    window.api.send(sendChannel.openTiku, path);
  },
  openPath: (path: string) => {
    window.api.send(sendChannel.openPath, path);
  },
  deleteDiskFile: (path: string) => {
    window.api.send(sendChannel.deleteDiskFile, path);
  },
};

export const useFile = () => {
  const {
    fileCatalogChangeListener,
    oneBookFilesChangeListener,
    flashFilesChangeListener,
    tikuFilesChangeListener,
    getOneBookFiles,
    getFlashFiles,
    getTikuFiles,
    getFileCatalog,
    getDisks,
    reloadMyCDCase,
    openOneBook,
    openFlash,
    openTiku,
    openPath,
    deleteDiskFile,
  } = isWeb ? webHandlers : desktopHandler;
  return {
    fileCatalogChangeListener,
    oneBookFilesChangeListener,
    flashFilesChangeListener,
    tikuFilesChangeListener,
    getOneBookFiles,
    getFileCatalog,
    getFlashFiles,
    getTikuFiles,
    getDisks,
    reloadMyCDCase,
    openOneBook,
    openFlash,
    openTiku,
    openPath,
    deleteDiskFile,
  };
};
